/**
 * Public front-page signup value panel (Epic 20 S20.2; S24.1 rewire).
 *
 * Value/CTA panel anchored `id="signup"`: gold kicker + heading + a short value
 * paragraph, one full-width golden "Kokeile maksutta" button, and a trust line.
 * The button navigates straight to `/auth/signup`
 * (instant account creation) — replacing the former Brevo double-opt-in waitlist
 * form (firstname/email/consent → `submitOriginalsSignup`), retired in S24.1.
 * Hardcoded Finnish (Epic 20 i18n exception).
 *
 * @module components/originals/home/SignupCta
 */

import { useNavigate } from 'react-router-dom';
import { Button } from '../../ui/Button';

export function SignupCta(): JSX.Element {
  const navigate = useNavigate();

  return (
    <section id="signup" className="px-4 py-16 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-2xl rounded-3xl bg-surface-cream p-8 shadow-lg sm:p-10">
        <p className="text-sm font-semibold uppercase tracking-wide text-accent-gold">
          Haluatko kokeilla Sagamoonia?
        </p>
        <h2 className="mt-2 font-whimsy text-3xl text-text-twilight-warm-brown">
          Tehkää ideoistanne yhdessä ikiomia satuja.
        </h2>
        <p className="mt-4 text-text-twilight-warm-brown/80">
          Luo maksuton tili, niin pääsette heti tekemään perheen ensimmäisen sadun yhdessä.
        </p>

        <Button
          variant="golden"
          size="lg"
          type="button"
          fullWidth
          className="mt-8"
          onClick={() => navigate('/auth/signup')}
        >
          Kokeile maksutta
          <span aria-hidden="true" className="ml-1">
            →
          </span>
        </Button>

        <p className="mt-4 text-center text-xs text-text-twilight-warm-brown/60">
          Rekisteröityminen vie alle minuutin · Suomalainen tiimi · GDPR-yhteensopiva
        </p>
      </div>
    </section>
  );
}
